import { render } from "./TicketDisplay.vue?vue&type=template&id=d0fb1340&scoped=true&lang=pug"
import script from "./TicketDisplay.vue?vue&type=script&lang=ts"
export * from "./TicketDisplay.vue?vue&type=script&lang=ts"

import "./TicketDisplay.vue?vue&type=style&index=0&id=d0fb1340&lang=scss"
import "./TicketDisplay.vue?vue&type=style&index=1&id=d0fb1340&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d0fb1340"

export default script